module.exports = __webpack_public_path__ + "img/zt.94067afc.png";